import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

export const AdvisorContactCardWrapper = styled.div`
  width: 100%;
  position: relative;
  text-align: left;
  align-items: center;
  display: flex;
`;

export const AdvisorHeadshotWrapper = styled.div`
  width: ${space('x10')};
  margin-right: ${space('md')};

  @media screen and (${query.atLeast('tablet')}) {
    width: 76px; // needs unique size to account for border and box-shadow
  }
`;

export const AdvisorDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const AdvisorTitle = styled.h5`
  ${font('subhead-xs')};
  line-height: 1.2;
  padding-bottom: ${space('xs')};
  color: ${color('fg')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('subhead-sm')};
    line-height: 1.2;
  }

  @media screen and (${query.atLeast('max')}) {
    ${font('subhead-md')};
    line-height: 1.2;
  }
`;

export const AdvisorSubTitles = styled.h6`
  ${font('body-xxs-light')};
  color: ${color('gray5')};
  line-height: 1.2;
  padding-bottom: 0;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-sm-light')};
    line-height: 1.2;
  }

  @media screen and (${query.atLeast('max')}) {
    ${font('body-md-light')};
    line-height: 1.2;
  }
`;
